import nodeClient from "./node-client";

export const fetchRoles = async (query = "") => {
  const response = await nodeClient.get(
    `service/private/v0/list/role?${encodeURI(query)}`
  );
  return response?.data;
};

export const updateRole = async (payload) => {
  const response = await nodeClient.post(
    `/service/private/v0/add/role`,
    payload
  );
  return response?.data;
};
export const getRole = async (params = "") => {
  const response = await nodeClient.get(
    `/service/private/v0/get/role?${encodeURI(params)}`
  );
  return response?.data;
};
export const getRoleLogs = async () => {
  const response = await nodeClient.get(`service/private/v0/get/role/log`);
  return response?.data?.result;
};
